module.exports = __webpack_public_path__ + "media/images/asta-d553bc8c9dc73d384c223a358f6a2f03.jpg";